/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One team's standing within a GROUPS_KNOCKOUT group pool.
 * @export
 * @interface TournamentBracketGroupStanding
 */
export interface TournamentBracketGroupStanding {
    /**
     * 
     * @type {string}
     * @memberof TournamentBracketGroupStanding
     */
    participantId?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentBracketGroupStanding
     */
    played?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentBracketGroupStanding
     */
    wins?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentBracketGroupStanding
     */
    losses?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentBracketGroupStanding
     */
    draws?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentBracketGroupStanding
     */
    pointsFor?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentBracketGroupStanding
     */
    pointsAgainst?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentBracketGroupStanding
     */
    points?: number;
}

/**
 * Check if a given object implements the TournamentBracketGroupStanding interface.
 */
export function instanceOfTournamentBracketGroupStanding(value: object): value is TournamentBracketGroupStanding {
    return true;
}

export function TournamentBracketGroupStandingFromJSON(json: any): TournamentBracketGroupStanding {
    return TournamentBracketGroupStandingFromJSONTyped(json, false);
}

export function TournamentBracketGroupStandingFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentBracketGroupStanding {
    if (json == null) {
        return json;
    }
    return {
        
        'participantId': json['participantId'] == null ? undefined : json['participantId'],
        'played': json['played'] == null ? undefined : json['played'],
        'wins': json['wins'] == null ? undefined : json['wins'],
        'losses': json['losses'] == null ? undefined : json['losses'],
        'draws': json['draws'] == null ? undefined : json['draws'],
        'pointsFor': json['pointsFor'] == null ? undefined : json['pointsFor'],
        'pointsAgainst': json['pointsAgainst'] == null ? undefined : json['pointsAgainst'],
        'points': json['points'] == null ? undefined : json['points'],
    };
}

export function TournamentBracketGroupStandingToJSON(json: any): TournamentBracketGroupStanding {
    return TournamentBracketGroupStandingToJSONTyped(json, false);
}

export function TournamentBracketGroupStandingToJSONTyped(value?: TournamentBracketGroupStanding | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'participantId': value['participantId'],
        'played': value['played'],
        'wins': value['wins'],
        'losses': value['losses'],
        'draws': value['draws'],
        'pointsFor': value['pointsFor'],
        'pointsAgainst': value['pointsAgainst'],
        'points': value['points'],
    };
}

